export default "__VITE_ASSET__CXHii3Km__"